:host {
  display: block;
}

.input-checkbox-toggle {
  font-family: var(--typography-font-input-checkbox-toggle);
  color: var(--clrs-text-input-checkbox-toggle);
}

.input-checkbox-toggle--error {
  color: var(--clrs-input-checkbox-toggle-error);
}

.input-checkbox-toggle__button {
  @apply flex box-border self-stretch overflow-visible relative select-none py-3 px-5 border-solid border;
  @apply transition-colors duration-300 cursor-pointer;

  border-radius: var(--border-radius-input-checkbox-toggle);
  background-color: var(--clrs-bg-input-checkbox-toggle-unselected);
  border-color: var(--clrs-border-input-checkbox-toggle-unselected);
}

.input-checkbox-toggle__button--checked {
  background-color: var(--clrs-bg-input-checkbox-toggle-selected);
  border-color: var(--clrs-input-checkbox-toggle-selected);
}

.input-checkbox-toggle__button--disabled {
  @apply cursor-default opacity-50;
}

.input-checkbox-toggle__button--error {
  background-color: var(--clrs-bg-input-checkbox-toggle-error);
  border-color: var(--clrs-input-checkbox-toggle-error);
}

.input-checkbox-toggle__checkbox {
  @apply relative flex-none w-5 h-5 box-border rounded border-solid border border-clrs-neutral-true-grey transition-colors duration-300;
  @apply after:content-[''] after:block after:absolute after:w-[5px] after:h-[10px] after:border-solid after:border-t-0 after:border-l-0 after:border-b-2 after:border-r-2 after:border-b-white after:border-r-white after:left-[6px] after:bottom-[5px] after:rotate-45;
}

.input-checkbox-toggle__checkbox--checked {
  background-color: var(--clrs-input-checkbox-toggle-selected);
}

.input-checkbox-toggle__checkbox--disabled {
  background-color: var(--clrs-bg-input-checkbox-toggle-checkbox-disabled);
}

.input-checkbox-toggle__checkbox--checked-disabled {
  background-color: var(--clrs-input-checkbox-toggle-selected);
}

.input-checkbox-toggle__lock-icon {
  color: var(--clrs-input-checkbox-toggle-selected);
}
